import api from './api';

export function saveGlobalDebt(data) {
  return api({
    method: 'post',
    url: `${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/global-debt`,
    headers: {
      "content-type": "form-data"
    },
    data: data,
  });
}
